/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_ChannelInputs */

const en_mobile_ota_channel = /** @type {(inputs: Mobile_Ota_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel`)
};

const es_mobile_ota_channel = /** @type {(inputs: Mobile_Ota_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal`)
};

/**
* | output |
* | --- |
* | "Channel" |
*
* @param {Mobile_Ota_ChannelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_channel = /** @type {((inputs?: Mobile_Ota_ChannelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_ChannelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_channel(inputs)
	return en_mobile_ota_channel(inputs)
});